export type PriorityLevel = 'normal' | 'high' | 'extreme';

export interface PriorityMeta {
    label: string;
    description: string;
}

export const PRIORITY_LEVELS: Record<PriorityLevel, PriorityMeta> = {
    normal: {
        label: 'Normal',
        description: 'Waits its turn like everyone else'
    },
    high: {
        label: 'High',
        description: 'Cuts the line, but politely'
    },
    extreme: {
        label: 'Extreme',
        description: 'Drop everything. Yes, even that.'
    }
};
